import { Navigate, type RouteObject } from 'react-router-dom';
import AssetsPage, { defaultTab } from './pages/AssetsPage';
import AssetPage from './pages/AssetPage';
import manufacturerRoutes from './manufacturer/routes';
import modelRoutes from './model/routes';
import assetTypeRoutes from './assetType/routes';
import locationRoutes from './location/routes';
import NewMaintenancePlanPage from './pages/NewMaintenancePlanPage';

const routes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={defaultTab} replace />,
  },
  {
    path: 'list',
    children: [
      {
        index: true,
        element: <AssetsPage tab="list" />,
      },
    ],
  },
  {
    path: 'manufacturers',
    children: manufacturerRoutes,
  },
  {
    path: 'models',
    children: modelRoutes,
  },
  {
    path: 'types',
    children: assetTypeRoutes,
  },
  {
    path: 'locations',
    children: locationRoutes,
  },
  {
    path: ':id',
    children: [
      {
        index: true,
        element: <Navigate to="details" replace />,
      },
      {
        path: 'work-orders',
        element: <AssetPage tab="work-orders" />,
      },
      {
        path: 'findings',
        element: <AssetPage tab="findings" />,
      },
      {
        path: 'maintenance-plan',
        element: <NewMaintenancePlanPage />,
      },
      {
        path: ':tab',
        element: <AssetPage />,
      },
    ],
  },
];

export default routes;
